// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root{
  margin-top: 130px;
}
.container {
    margin: 0;
    font-family: Arial, sans-serif;
    width: 100%;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-bar {
    width: 70%;
    height: 15px;
    background-color: #007bff;
    border-radius: 5px;
  }
  
  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    width: 100%;
    margin: 0;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px 15px;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none; 
    background-color: #ff6f61;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination-controls span {
    font-size: 16px;
    margin-left: 10px;
  }
  
  .status-badge {
    padding: 5px 10px;
    border-radius: 12px;
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
  
  .status-badge-active {
    background-color: #57eb7a;
  }
  
  .status-badge-inactive {
    background-color: #ef4455;
  }
  
  .status-badge-pending {
    background-color: #eec240;
    color: black;
  }
  
  .action-button {
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: rgb(236, 134, 26);
    border: 1px solid rgb(236, 134, 26);
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-without-border:hover{
    background-color: rgba(150, 214, 241, 0.87);
  }
  
  .action-button:hover {
    background-color: rgb(236, 134, 26);
    color: white;
  }
  
  .expand-icon {
    cursor: pointer;
    text-align: center;
  }

  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  

  .create-button{
    background-color: #ff6f61;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    height: 35px;
  }

  .create-button:hover {
    background-color: #e17b22;
    color: white;
  }


  .submit-button4 {
    
    border: none;
    background-color: #ff6f61;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button4:hover {
    outline: none;
    background-color: #e65c54;
  }

  .btn-create {
    background-color: #F3903F; 
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;
  }
  
  .btn-create:hover:enabled {
    background-color: #d6792f; 
    transform: translateY(-1px);
  }
  
  .btn-create:disabled {
    background-color: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
  }`, "",{"version":3,"sources":["webpack://./src/pages/FunctionUser/style.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;AACnB;AACA;IACI,SAAS;IACT,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,wBAAwB;IACxB,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,mCAAmC;IACnC,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;EAGA;;IAEE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8EAA8E;EAChF;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd","sourcesContent":["\n.root{\n  margin-top: 130px;\n}\n.container {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    width: 100%;\n  }\n  \n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .progress-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .progress-bar {\n    width: 70%;\n    height: 15px;\n    background-color: #007bff;\n    border-radius: 5px;\n  }\n  \n  .badge-status {\n    display: inline-block;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 12px;\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: center;\n  }\n  \n  .table tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .table-container {\n    width: 100%;\n    margin: 0;\n    padding: 10px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .table-title {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n  }\n  \n  .search-input {\n    width: 40%;\n    padding: 10px;\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n  }\n  \n  .styled-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: white;\n  }\n  \n  .styled-table th,\n  .styled-table td {\n    padding: 12px 15px;\n  }\n  \n  .styled-table th {\n    background-color: #f3f4f6;\n    color: #333;\n  }\n  \n  .clickable-row {\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .clickable-row:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .expanded-content {\n    padding: 10px;\n    background-color: #e9e9e9;\n    border-radius: 4px;\n  }\n  \n  .pagination-controls {\n    text-align: center;\n  }\n  \n  .pagination-controls button {\n    padding: 8px 12px;\n    margin: 0 5px;\n    border: none; \n    background-color: #ff6f61;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .pagination-controls button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n  }\n  \n  .pagination-controls span {\n    font-size: 16px;\n    margin-left: 10px;\n  }\n  \n  .status-badge {\n    padding: 5px 10px;\n    border-radius: 12px;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n  }\n  \n  .status-badge-active {\n    background-color: #57eb7a;\n  }\n  \n  .status-badge-inactive {\n    background-color: #ef4455;\n  }\n  \n  .status-badge-pending {\n    background-color: #eec240;\n    color: black;\n  }\n  \n  .action-button {\n    padding: 3px 4px;\n    margin-right: 5px;\n    border: none;\n    background-color: transparent;\n    color: rgb(236, 134, 26);\n    border: 1px solid rgb(236, 134, 26);\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .action-button-without-border{\n    padding: 2px 3px;\n    margin-right: 5px;\n    border: none; \n    background-color: transparent;\n    color: rgb(236, 26, 26);\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .action-button-without-border:hover{\n    background-color: rgba(150, 214, 241, 0.87);\n  }\n  \n  .action-button:hover {\n    background-color: rgb(236, 134, 26);\n    color: white;\n  }\n  \n  .expand-icon {\n    cursor: pointer;\n    text-align: center;\n  }\n\n  .badge-status {\n    display: inline-block;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 12px;\n  }\n  \n\n  .create-button{\n    background-color: #ff6f61;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 5px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    height: 35px;\n  }\n\n  .create-button:hover {\n    background-color: #e17b22;\n    color: white;\n  }\n\n\n  .submit-button4 {\n    \n    border: none;\n    background-color: #ff6f61;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    outline: none;\n    height: 30px !important;\n  }\n  \n  .submit-button4:hover {\n    outline: none;\n    background-color: #e65c54;\n  }\n\n  .btn-create {\n    background-color: #F3903F; \n    color: #fff;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 8px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    outline: none;\n    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;\n  }\n  \n  .btn-create:hover:enabled {\n    background-color: #d6792f; \n    transform: translateY(-1px);\n  }\n  \n  .btn-create:disabled {\n    background-color: #e0e0e0;\n    color: #999;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
